import CheckmarkBold from "svg/checkmark-bold.svg";

import { isArrangementLocked } from "helpers/at-need";

import { STEP_LABELS } from "./constants";
import { useArrangement } from "./ArrangementContext";

export default function ArrangementProgressBar() {
  const { state, config, goToStep, isReadOnly, stepStatus } = useArrangement();
  const { currentStep } = state;

  const isSubmitted = isArrangementLocked(config?.arrangement_status);

  const steps = STEP_LABELS.map((label, idx) => ({ label, idx }));
  const stepCount = steps.length;

  return (
    <nav aria-label="Arrangement progress" className="w-full px-4 pb-6">
      <div
        className="grid"
        style={{ gridTemplateColumns: `repeat(${stepCount}, 1fr)` }}
      >
        {steps.map(({ label, idx }, position) => {
          const isActive = idx === currentStep;
          const isCompleted = idx < currentStep || stepStatus[idx] === true;
          const canNavigate = isReadOnly || (isCompleted && !isSubmitted);

          return (
            <div key={label} className="relative flex flex-col items-center">
              {/* Connector line to next step */}
              {position < stepCount - 1 && (
                <div
                  className={`absolute h-0.5 ${
                    idx < currentStep ? "bg-sage" : "bg-olive/30"
                  }`}
                  style={{ left: "50%", right: "-50%", top: "23px" }}
                />
              )}

              <button
                onClick={() => canNavigate && goToStep(idx)}
                disabled={!canNavigate}
                className="relative z-10 flex flex-col items-center gap-1.5"
              >
                {isCompleted ? (
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-sage text-white">
                    <CheckmarkBold className="h-3.5 w-3.5" />
                  </div>
                ) : (
                  <div
                    className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold transition-colors ${
                      isActive
                        ? "border-2 border-evergreen bg-white text-evergreen"
                        : "bg-oat text-white"
                    }`}
                  >
                    {position + 1}
                  </div>
                )}
                <span
                  className={`hidden whitespace-nowrap text-base sm:block ${
                    isActive
                      ? "font-bold text-evergreen"
                      : isCompleted
                        ? "text-evergreen"
                        : "text-olive"
                  }`}
                >
                  {label}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </nav>
  );
}
